import { gql } from '@apollo/client'

const DISH_ADDITIONAL_INGREDIENT_FRAGMENT = gql`
  fragment DishAdditionalIngredientFragment on DishAdditionalIngredient {
    ingredient {
      id
      name
      isCurationEnabled
    }
    type
    isSuggestedByAi
    overrides {
      word
      originField
    }
  }
`
export default DISH_ADDITIONAL_INGREDIENT_FRAGMENT
